import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../services/user.service';
import { ScreeningService } from '../../screening-module/services/screening.service';
import { ClientService } from '../../clients-module/services/client.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { UserLight } from '../models/userLight';
import { SimpleDataFilter } from 'src/app/models/simpleDataFilter';
import { PaginationEventData } from 'src/app/shared-components-module/pagination-top/models/paginationEventData';
import { FilteringService } from 'src/app/services/filtering.service';
import { UserFilter } from '../models/userFilter';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.less']
})

export class UsersComponent implements OnInit, OnDestroy, AfterViewInit {
    public displayFilters = true;
    public loaded = false;
    public selectedClientId: number;

    constructor(public auth: AuthService,
        public users: UserService,
        public screening: ScreeningService,
        public clients: ClientService,
        public toast: ToastrService,
        public location: Router,
        public filtering: FilteringService,
        public activatedRoute: ActivatedRoute
    ) { }

    public ngOnInit(): void {
        //the app-users-list component handles fetching its data
    }

    public get filteredUsers(): Array<UserLight> {
        if (!this.users.users) return [];
        return this.users.users;
    }

    public ngAfterViewInit(): void {
    }

    public ngOnDestroy(): void {
        this.filtering.filters = [];
        this.users.users = [];
    }

    public clearFilters(): void {
        this.users.userFilter = new UserFilter();
        this.users.users = [];
        this.users.FetchUserList(this.users.userFilter);
    }

    public onPaginationChanged(event: PaginationEventData) {
        this.filtering.filters.push(new SimpleDataFilter('offsetCount', event.offset.toString(), true));
        this.users.users = [];
        this.users.FetchUserList(this.users.userFilter);
        this.filtering.clearTransientFilters();
    }

    public viewUser(c: UserLight): void {
        this.location.navigateByUrl(`users/review/${c.id}/${this.clients.currentClient.id}`);
    }


    public showFilters(): void {
        this.displayFilters = !this.displayFilters;
    }

    public gotoUser(c: UserLight): void {
        this.location.navigateByUrl(`/users/review/${c.id}/${c.clientId}`);
    }

    public addNewUser(): void {
        //if not a CRA, just route to the clientId of the currently logged in user 
        if(this.auth.UserInRole('CRA')) {
            this.location.navigateByUrl(`/users/new`);
        } else {
            this.location.navigateByUrl(`/users/new/${this.auth.loggedInUser.clientId}`);
        }
    }

    applyFilters(): void {
        if (this.users.userFilter.firstName) this.filtering.filters.push(new SimpleDataFilter('firstName', this.users.userFilter.firstName));
        if (this.users.userFilter.lastName) this.filtering.filters.push(new SimpleDataFilter('lastName', this.users.userFilter.lastName));
        if (this.users.userFilter.userName) this.filtering.filters.push(new SimpleDataFilter('userName', this.users.userFilter.userName));
        if (this.users.userFilter.email) this.filtering.filters.push(new SimpleDataFilter('email', this.users.userFilter.email));
        this.users.users = [];
        this.users.FetchUserList(this.users.userFilter);
    }
}
